import React, { useEffect, useState } from 'react';
import { Grid } from '@naf/grid';
import { TextVariant } from '@naf/text';
import { HttpStatus } from '@components/HttpStatus';
import { LayoutWithMainContent } from '@components/layout/Layout';
import InternalServerErrorImage from '@assets/images/InternalServerError.svg';
import { InternalSearchCardType } from '@components/layout/InternalSearchMetaData';
import { MAIN_URL } from '@lib/constants';
import * as S from './InternalServerError.styles';

interface InternalServerErrorProps {
  withoutLayout?: boolean;
}

export const InternalServerError = ({ withoutLayout = false }: InternalServerErrorProps) =>
  withoutLayout ? (
    <InternalServerErrorInner />
  ) : (
    <LayoutWithMainContent
      title="NAF - 500"
      description="500 - Vi klarer ikke å vise siden"
      url=""
      imgUrl=""
      disableCanonical
      internalSearchMetaData={{ cardType: InternalSearchCardType.Simple }}
      isHiddenFromSearch
    >
      <InternalServerErrorInner />
    </LayoutWithMainContent>
  );

const InternalServerErrorInner = () => {
  const title = 'Serverfeil';
  const description = 'Noe gikk galt under lastingen av nettsiden. Vennligst vent en liten stund og prøv igjen.';
  const buttonText = 'Gå til forsiden';

  const [baseUrl, setBaseUrl] = useState(MAIN_URL);

  useEffect(() => {
    setBaseUrl(window.location.origin);
  }, []);

  return (
    <S.Container role="main">
      <S.Wrapper>
        <Grid>
          <S.StyledGridCol s="12" m="12" l="6" xl="6">
            <HttpStatus code={500}>
              <S.Header variant={TextVariant.Header1}>{title}</S.Header>
              <S.StyledText tag="p" variant={TextVariant.ArticleTextLarge}>
                {description}
              </S.StyledText>
              <S.StyledButton href={baseUrl}>{buttonText}</S.StyledButton>
              <S.StyledButtonMobile size="small" href={baseUrl}>
                {buttonText}
              </S.StyledButtonMobile>
            </HttpStatus>
          </S.StyledGridCol>
          <S.StyledImageGridCol s="12" m="12" l="6" xl="6">
            <InternalServerErrorImage alt="Internal Server Error" />
          </S.StyledImageGridCol>
        </Grid>
      </S.Wrapper>
    </S.Container>
  );
};
